package org.braunequip.web.util

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.internal.JSJoda.DateTimeFormatter

fun Number.pretty(): String = asDynamic().toLocaleString() as String

fun parseSelectedItemsTextBySize(size: Int): String {
    return if (size == 1) "1 Item Selected" else "${size} Items Selected"
}

fun parseSelectedItemsTextByList(items: List<String>): String {
    return if (items.size == 1) "1 Item Selected" else "${items.size} Items Selected"
}

fun formatDate(date: String): String {
    //Cheap "format", simply removing everything from T
    return if (date.isNotEmpty() && date.isNotBlank()) {
        date.substringBefore("T")
    } else {
        ""
    }
}

fun formatDateTime(timestampString: String): String {
    val timestamp = try {
        LocalDateTime.parse(timestampString)
    } catch (e: Exception) {
        null
    }

    // Cheap format, simply removing everything from T
    return if (timestamp != null) {
        val date = timestamp.date.toString() // e.g., "2025-04-23"
        val hour = timestamp.hour.toString().padStart(2, '0')
        val minute = timestamp.minute.toString().padStart(2, '0')
        return "$date | $hour:$minute"
    } else {
        "-"
    }
}